import { ReactElement } from 'react'

interface TabProps {
  children: ReactElement
  clickName?: string
  hidden?: boolean
  title: string
}

export function Tab({ children }: TabProps): JSX.Element {
  return children
}
